var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "node-view-wrapper",
    { staticClass: "collapsed-mail-wrapper" },
    [
      _vm.isCollapsed
        ? _c(
            "a-tooltip",
            {
              attrs: {
                title: "Kısaltılmış içeriği görüntüle",
                placement: "top",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "collapsed-mail-button",
                  on: { click: _vm.expand },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("more_horiz"),
                  ]),
                ]
              ),
            ]
          )
        : _c("div", {
            staticClass: "mail-content",
            domProps: { innerHTML: _vm._s(_vm.node.attrs.content) },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }